import { useRef, useState } from 'react';

export const useStepsCarousel = (totalItems) => {
    const carouselRef = useRef(null);
    const [activeCardIndex, setActiveCardIndex] = useState(0);

    const scrollToCard = (index) => {
        if (index < 0 || index >= totalItems) return;

        setActiveCardIndex(index);

        if (carouselRef.current) {
            const cardNodes = carouselRef.current.children;
            if (cardNodes[index]) {
                let block = "nearest";
                let inline = "center";

                if (index === 0) inline = "start";
                if (index === totalItems - 1) inline = "end";

                cardNodes[index].scrollIntoView({ behavior: 'smooth', block, inline });
            }
        }
    };

    const handleNext = () => {
        scrollToCard(activeCardIndex + 1);
    };

    const handlePrev = () => {
        scrollToCard(activeCardIndex - 1);
    };

    return {
        carouselRef,
        activeCardIndex,
        scrollToCard,
        handleNext,
        handlePrev,
        isFirst: activeCardIndex === 0,
        isLast: activeCardIndex === totalItems - 1
    };
};
